/**
 * Build the multipart body for a CSV import call: the file plus any
 * entity-specific text fields (e.g. the services import's `category_map`).
 * Empty, null and undefined field values are left out.
 */
export function buildImportFormData(file, extraFields = {}) {
  const formData = new FormData();
  formData.append("file", file);
  Object.entries(extraFields || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  });
  return formData;
}

/**
 * True when an import finished but not cleanly: rows rejected by validation,
 * or, for imports that go row by row, rows that failed while importing
 * (`failed`) or were not reached before the time limit (`not_processed`).
 */
export function importHasIssues(importResult) {
  if (!importResult) return false;
  return (
    (importResult.error_count ?? 0) > 0 ||
    (importResult.failed ?? 0) > 0 ||
    (importResult.not_processed ?? 0) > 0
  );
}
